// @ts-check
import moment from 'moment';

/**
 * Checks if a date is null or a specific database value.
 *
 * The function considers values like `1900-01-01T00:00:00` or '0001-01-01T00:00:00' as null.
 *
 * @param {Date | string | null | undefined} date - The date value.
 * @returns {boolean} `true` if the date is null or a database-specific value, `false` otherwise.
 */
export function isDateNull(date) {
  if (!date) {
    return true;
  }

  if (typeof date === 'string') {
    return date === '1900-01-01T00:00:00'
      || date === '0001-01-01T00:00:00'
      || Number.isNaN(new Date(date));
  }

  if (typeof date === 'object') {
    const newDate = new Date(date);

    return newDate.toString() === 'Invalid Date'
      || Number.isNaN(newDate);
  }

  return true;
}

/**
 * Formats the provided date into the specified format.
 *
 * @param {Date | string | number} date - The date to format.
 * @param {string} format - The format string.
 * @returns {string} The formatted date string.
 * @example
 * // Returns '17/04/2024' for today's date in 'DD/MM/YYYY' format
 * formatDate(new Date(), 'DD/MM/YYYY');
 */
export function formatDate(date, format) {
  return moment(date).format(format);
}

/**
 * Formats the provided date into the specified format.
 *
 * @param {Date } date - The date to format.
 * @returns {string} The formatted date string.
 * @example
 * // Returns '17/04/2024' for today's date in 'DD/MM/YYYY' format
 * formatDate(new Date(), 'DD/MM/YYYY');
 */
export function formatDateToISO(date) {
  const fechaLocal = new Date(date);
  const fechaISO = new Date(fechaLocal.getTime() - (fechaLocal.getTimezoneOffset() * 60000)).toISOString().slice(0, -1);
  return fechaISO;
  // return new Date(year, month, day, hours, minutes);
}

/**
 * Sets locale for dates.
 * @param {string} locale
 * @returns {void}
 */
export function setDateLocale(locale) {
  moment.locale(locale);
}
